
import BestSellerCard from './components/M15-BestSellerCard.vue'
import CampaignCard from './components/M15-CampaignCard.vue'

export default {
    name: 'promotion',
    data(){
        return {
            maxBestsellerListLength: 2,
            maxcampaignsListLength: 3,
        }
    },
    computed:{
        label() {
            if (this.$store.state.main.labels) {
                return this.$store.state.main.labels
            }
        },
        bestsellersList() {
            if (this.$store.state.main.promotedCards.bestsellersList) {
                return this.$store.state.main.promotedCards.bestsellersList.slice(0, this.maxBestsellerListLength).map(item => item)
            }
        },
        campaignsList() {
            if (this.$store.state.main.promotedCards.campaignsList) {
                return this.$store.state.main.promotedCards.campaignsList.slice(0, this.maxcampaignsListLength).map(item => item)
            }
        },
        bestsellersTitle() {
            if (this.$store.state.main.promotedCards.bestsellersTitle) {
                return this.$store.state.main.promotedCards.bestsellersTitle
            }
        },
        campaignTitle() {
            if (this.$store.state.main.promotedCards.campaignsTitle) {
                return this.$store.state.main.promotedCards.campaignsTitle
            }
        },
        hasPromotionCardData() {
            return (this.$store.state.main.promotedCards.campaignsList.length === 0 && this.$store.state.main.promotedCards.bestsellersList.length === 0)
        }
    },
    methods: {
  
    },
    components : {
        BestSellerCard,
        CampaignCard
    }
}